export default "__VITE_ASSET__DCVp2FLG__"